"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ContractIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-755.000000, -237.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(753.000000, 235.000000)",
        fill: color,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(10.500000, 10.500000) rotate(-135.000000) translate(-10.500000, -10.500000) translate(6.500000, -1.000000)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            transform: "translate(4.000000, 11.500000) rotate(-180.000000) translate(-4.000000, -11.500000) translate(-0.000000, 0.000000)",
            fillRule: "nonzero",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(0.000000, 0.000000)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                transform: "translate(4.000000, 11.500000) rotate(180.000000) translate(-4.000000, -11.500000) translate(0.000000, 0.000000)",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  transform: "translate(0.000000, 0.000000)",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    d: "M3,6.75631072 L3,1.27207794 C3,0.719793189 3.44771525,0.272077939 4,0.272077939 C4.51283584,0.272077939 4.93550716,0.658118129 4.99327227,1.15545681 L5,1.27207794 L5,6.76521233 L6.2799128,5.43613424 C6.63365388,5.06903123 7.20027359,5.03079378 7.59815054,5.32849582 L7.69388346,5.40992416 C8.06098648,5.76366524 8.09922393,6.33028495 7.80152189,6.7281619 L7.72009354,6.82389482 L4.69239217,9.96596217 C4.32252214,10.3498034 3.72375417,10.3719721 3.32730755,10.0364227 L3.23960764,9.95263995 L0.267309022,6.75263995 C-0.108552819,6.34798415 -0.0852106997,5.71524958 0.319445106,5.33938773 C0.692973542,4.99243834 1.26084128,4.98563907 1.64162084,5.30491873 L1.73269732,5.39152382 L3,6.75631072 Z M5,16.5158116 L5,22 C5,22.5522847 4.55228475,23 4,23 C3.48716416,23 3.06449284,22.6139598 3.00672773,22.1166211 L3,22 L3,16.5069163 L1.72009037,17.8359476 C1.36634929,18.2030507 0.799729582,18.2412881 0.401852628,17.9435861 L0.306119709,17.8621577 C-0.0609833033,17.5084166 -0.0992207538,16.9417969 0.198481286,16.54392 L0.279909629,16.4481871 L3.30761101,13.3061197 C3.67748103,12.9222785 4.27624901,12.9001098 4.67269563,13.2356592 L4.76039553,13.3194419 L7.73269415,16.5194419 C8.10855599,16.9240977 8.08521387,17.5568323 7.68055807,17.9326942 C7.30702963,18.2796435 6.73916189,18.2864428 6.35838234,17.9671632 L6.26730585,17.8805581 L5,16.5158116 Z"
                  })
                })
              })
            })
          })
        })
      })
    })
  })]
});

ContractIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = ContractIcon;
exports.default = _default;